import * as XLSX from 'xlsx'
import type { Form, FormSubmission } from '@/stores/forms'
import { formatSubmissionDateTimeKyiv, submissionCellValue } from './dateKyiv'

function getFormName(forms: Form[], formId: number): string {
  return forms.find(f => f.id === formId)?.name ?? 'Невідома форма'
}

function getStatusText(status?: string): string {
  switch (status) {
    case 'approved':
      return 'Підтверджено'
    case 'disqualified':
      return 'Дискваліфіковано'
    default:
      return 'Очікує'
  }
}

function orderedFieldKeys(form: Form | undefined, data: Record<string, unknown>): string[] {
  const keys = new Set(Object.keys(data))
  const ordered: string[] = []
  if (form) {
    const byOrder = [...form.fields].sort((a, b) => a.order - b.order)
    for (const f of byOrder) {
      if (keys.has(f.id)) {
        ordered.push(f.id)
        keys.delete(f.id)
      }
    }
  }
  for (const k of keys) ordered.push(k)
  return ordered
}

function buildRow(forms: Form[], s: FormSubmission): string[] {
  const form = forms.find(f => f.id === s.form_id)
  const row: string[] = [
    formatSubmissionDateTimeKyiv(s.created_at),
    getFormName(forms, s.form_id),
    getStatusText(s.status)
  ]
  const keys = orderedFieldKeys(form, s.submission as Record<string, unknown>)
  for (const key of keys) {
    row.push(submissionCellValue(s.submission[key]))
  }
  row.push(s.file_link || '')
  return row
}

export function downloadSubmissionsXlsx(
  forms: Form[],
  submissions: FormSubmission[],
  filename: string
) {
  const rows = submissions.map(s => buildRow(forms, s))
  const wb = XLSX.utils.book_new()
  const ws = XLSX.utils.aoa_to_sheet(rows)
  XLSX.utils.book_append_sheet(wb, ws, 'Відправлення')
  XLSX.writeFile(wb, filename)
}
